var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-0 shadow"},[_c('div',{staticClass:"card-body p-2",staticStyle:{"height":"calc(100vh - 130px)"}},[_c('ChatBox',{attrs:{"mode":"page"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }